var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCampaign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 27 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.105 11.25c0-1.108-0.607-2.064-1.5-2.584v-7.166c0-0.41-0.327-1.5-1.5-1.5-0.334 0-0.665 0.112-0.937 0.329l-3.986 3.189c-2.002 1.6-4.515 2.482-7.078 2.482h-9c-1.657 0-3 1.343-3 3v4.5c0 1.657 1.343 3 3 3h1.58c-0.065 0.491-0.102 0.991-0.102 1.5 0 1.864 0.434 3.626 1.198 5.2 0.243 0.501 0.774 0.8 1.331 0.8h3.482c1.221 0 1.954-1.399 1.214-2.37-0.769-1.009-1.226-2.267-1.226-3.63 0-0.521 0.076-1.021 0.207-1.5h1.316c2.562 0 5.076 0.882 7.077 2.482l3.986 3.189c0.266 0.213 0.596 0.329 0.937 0.329 1.168 0 1.5-1.068 1.5-1.5v-7.166c0.893-0.52 1.5-1.477 1.5-2.584zM22.605 17.879l-1.549-1.239c-2.531-2.025-5.711-3.14-8.951-3.14v-4.5c3.24 0 6.42-1.115 8.951-3.14l1.549-1.239v13.258z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampaign);
export default __webpack_public_path__ + "static/media/campaign.56e01f94401400ac22e684ca3acfff89.svg";
export { ForwardRef as ReactComponent };